import type { Language } from '../store/languageStore'

/** Pick Arabic / French / English UI text. French falls back to English if omitted. */
export function loc(language: Language | string, ar: string, en: string, fr?: string): string {
  if (language === 'ar') return ar
  if (language === 'fr') return fr || en
  return en
}

export function locLabel(
  language: Language | string,
  label: { ar: string; en: string; fr?: string }
): string {
  if (language === 'ar') return label.ar
  if (language === 'fr') return label.fr || label.en
  return label.en
}
